import * as React from 'react';
import classnames from 'classnames';

import Tooltip from 'components/Tooltip';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { __t, applyTranslations } from 'utils/language';

import './influencer-creator-network-list-item-chevron.scss';

applyTranslations(require('./influencer-creator-network-list-item-chevron.i18n.json'));

type Props = {
  isExpanded: boolean,
  isClickable: boolean
};

const InfluencerCreatorNetworkListItemChevron = (
  {
    isExpanded,
    isClickable
  }: Props
): JSX.Element => {
  const chevronClasses = classnames('influencer-creator-network-list-item-chevron', {
    'influencer-creator-network-list-item-chevron--is-expanded': isExpanded
  });

  const message = (!isClickable)
    ? __t('influencer_creator_network_list_item_chevron.no_data')
    : undefined;

  return (
    <div className={chevronClasses}>
      <Tooltip key={message} message={message}>
        <SVGDynamicIcon
          name="chevron-down-custom-fg"
          width={15}
          height={8}
          customColor={(isClickable) ? 'black' : 'grey-light'}
          clickable={isClickable}
        />
      </Tooltip>
    </div>
  );
};

export default InfluencerCreatorNetworkListItemChevron;
